import { useTranslation } from "react-i18next";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "~/components/ui/dialog";
import { Button, ButtonProps } from "~/components/button";
import { IconProps } from "~/components/icon/icon";
import { FileUploadDropZone } from "./file-upload-drop-zone";

interface FileUploadDialogProps {
  open?: boolean;
  onOpenChange?: (isOpen: boolean) => void;
  onFileUpload: (acceptedFiles: File[]) => void;
  triggerButton?: ButtonProps;
  icon?: IconProps["name"];
  title: string;
  description?: string;
  accept?: Record<string, string[]>;
  multiple?: boolean;
  maxSizeMB?: number;
  isLoading?: boolean;
  error?: string;
}

export const FileUploadDialog = ({
  open,
  onOpenChange,
  onFileUpload,
  triggerButton,
  icon,
  title,
  description,
  accept,
  multiple = false,
  maxSizeMB,
  isLoading = false,
  error,
}: FileUploadDialogProps) => {
  const { t } = useTranslation(["general"]);

  const handleFileUpload = (files: File[]) => {
    onFileUpload(files);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      {triggerButton && (
        <DialogTrigger asChild>
          <Button {...triggerButton} />
        </DialogTrigger>
      )}
      <DialogContent className="overflow-visible">
        <DialogHeader className="items-start space-y-0 my-0 mb-8">
          <DialogTitle>{title}</DialogTitle>
          {description && (
            <DialogDescription className="text-left">
              {description}
            </DialogDescription>
          )}
        </DialogHeader>

        <div className="grid gap-5">
          <FileUploadDropZone
            icon={icon}
            onDrop={handleFileUpload}
            accept={accept}
            multiple={multiple}
            maxSizeMB={maxSizeMB}
            isLoading={isLoading}
            error={error}
          />
        </div>

        <DialogFooter className="flex justify-between items-center">
          <DialogClose asChild>
            <Button
              label={t("general:buttons.close")}
              variant="tertiary"
              size="small"
              disabled={isLoading}
            />
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
